export default __webpack_public_path__ + "static/media/09.8ea5c233.png";